import React from "react";
import { Header } from "@/widgets/header";
import { Footer } from "@/widgets/footer";

interface RootLayoutProps {
  children: React.ReactNode;
}

/**
 * RootLayout - 전역 레이아웃
 * 모든 페이지에 Header와 Footer를 자동으로 적용합니다
 */
export function RootLayout({ children }: RootLayoutProps) {
  return (
    <div className="min-h-screen w-full flex flex-col overflow-x-hidden">
      {/* Header */}
      <Header />

      {/* 페이지 콘텐츠 */}
      <main className="flex-1 flex flex-col">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
